import script from "./DeleteBrandConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteBrandConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteBrandConfirmDialog.vue?vue&type=style&index=0&id=8c8c5b54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c8c5b54"]])

export default __exports__